import { render, staticRenderFns } from "./ViewPatients.vue?vue&type=template&id=6d5e1a46&scoped=true&"
import script from "./ViewPatients.vue?vue&type=script&lang=js&"
export * from "./ViewPatients.vue?vue&type=script&lang=js&"
import style0 from "./ViewPatients.vue?vue&type=style&index=0&id=6d5e1a46&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d5e1a46",
  null
  
)

export default component.exports